import { render, staticRenderFns } from "./PublishEvent.vue?vue&type=template&id=222f1a68"
import script from "./PublishEvent.vue?vue&type=script&lang=js"
export * from "./PublishEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports